var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui main container"},[_c('LoginForm',{attrs:{"message":_vm.message,"isLoading":_vm.loading,"showRegisterButton":true},on:{"onLogin":_vm.login,"onRegister":_vm.signup}}),_c('div',{staticClass:"ui"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }